// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-mode-toggle {
  position: fixed;
  top: 12px;
  right: 70px;
  z-index: 99998;
  background: rgba(128, 128, 128, 0.15);
  border: none;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  transition: background 0.2s ease;
}
.dark-mode-toggle i {
  font-size: 18px;
  color: #667eea;
}
.dark-mode-toggle:hover {
  background: rgba(128, 128, 128, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kCAAA;UAAA,0BAAA;EACA,gCAAA;AACF;AACE;EACE,eAAA;EACA,cAAA;AACJ;AAEE;EACE,qCAAA;AAAJ","sourcesContent":[".dark-mode-toggle {\n  position: fixed;\n  top: 12px;\n  right: 70px;\n  z-index: 99998;\n  background: rgba(128, 128, 128, 0.15);\n  border: none;\n  border-radius: 50%;\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  backdrop-filter: blur(4px);\n  transition: background 0.2s ease;\n\n  i {\n    font-size: 18px;\n    color: #667eea;\n  }\n\n  &:hover {\n    background: rgba(128, 128, 128, 0.25);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
